import React, { useEffect } from 'react';
import { Button } from 'components';
import useFormHandler from 'hooks/useFormHandler';
import { Props } from 'types/modals';
import Base from '../../base';
import joi from 'joi';
import Input from 'components/dynamicInputs/input';
import { TextInputTypes } from 'types/dynamicInputs';

const schema = {
  reportTime: {
    value: '',
    label: 'Report time',
    input: 'INPUT',
    type: TextInputTypes.TEXT,
    required: false,
    joi: joi
      .string()
      .pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9](\s)?([AaPp][Mm])?$/)
      .allow('')
      .messages({
        'string.pattern.base': 'Invalid time format'
      })
  }
};

const EditReportTimeByPosition = ({ closing, onClose, params }: Props) => {
  const formHandler = useFormHandler(schema);

  useEffect(() => {
    formHandler.setFullForm({
      reportTime: params.reportTime || ''
    });
  }, [params.reportTime]);

  const handleSubmit = () => {
    formHandler.setIsSubmitting(true);
    onClose({ reportTime: formHandler.data.reportTime });
  };

  return (
    <Base
      header={`Edit report time for ${params.positionName}`}
      closing={closing}
      onClose={onClose}
      size="sm"
      footer={
        <>
          <Button
            text="Save"
            onClick={handleSubmit}
            disabled={formHandler.isSubmitting || !formHandler.data.reportTime || !formHandler.valid}
          />
          <Button text="Cancel" variant="secondary" onClick={() => onClose()} disabled={formHandler.isSubmitting} />
        </>
      }
    >
      <div style={{ margin: '16px 0' }}>
        <Input
          value={formHandler.data.reportTime}
          name="reportTime"
          type={TextInputTypes.TEXT}
          label={schema.reportTime.label}
          onChange={formHandler.setFormData('reportTime')}
          placeholder="e.g. 10:00 AM"
          error={formHandler.errors.reportTime}
          pristine={formHandler.pristine.reportTime}
          disabled={formHandler.isSubmitting}
        />
      </div>
    </Base>
  );
};

export default EditReportTimeByPosition;
